import { render, staticRenderFns } from "./CoverageFormulaSummary.vue?vue&type=template&id=6151208a&scoped=true"
import script from "./CoverageFormulaSummary.vue?vue&type=script&lang=js"
export * from "./CoverageFormulaSummary.vue?vue&type=script&lang=js"
import style0 from "./CoverageFormulaSummary.vue?vue&type=style&index=0&id=6151208a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6151208a",
  null
  
)

export default component.exports